export const FF_TEST_HISTORY = 'test-history';
export const FF__SCENARIO_TEST_GRAPH = 'scenario-time-graph';

export const FeatureFlag = {
  [FF_TEST_HISTORY]: FF_TEST_HISTORY,
  [FF__SCENARIO_TEST_GRAPH]: FF__SCENARIO_TEST_GRAPH,
};
